import React from 'react'
import { Box, Stack, Typography } from '@mui/material';

import Logo from '../assets/images/Logo-1.png';

const Footer = () => {
  return (
    <Box mt="80px" bgcolor={"transparent"}>
      <Stack gap="40px" alignItems="center" px="40px" pt="24px">
        <img src={Logo} alt="logo" width="125px" height="125px" />
        <Typography variant='h5' pb="40px" mt="20px">
          Made with ❤️ by Arnab
        </Typography>
      </Stack>
    </Box>
  )
}

export default Footer